/* eslint-disable react/prop-types */
import { graphql } from 'gatsby';
import React from 'react';
import Page from '../components/Page';
import PageMeta from '../components/PageMeta';
import { ResourceBrowser } from '../components/ResourceBrowser/ResourceBrowser';
import TextHero from '../components/TextHero';

const ResourcesPage = ({ data }) => {
  const { allContentfulResource, contentfulResourceLibraryPage } = data;
  const { pageMeta, hero } = contentfulResourceLibraryPage;

  const resources = allContentfulResource.edges.map((n) => n.node);

  return (
    <Page>
      <PageMeta {...pageMeta} />
      <TextHero {...hero} />
      <ResourceBrowser resources={resources} />
    </Page>
  );
};

export default ResourcesPage;

export const query = graphql`
  query ResourcesPageQuery {
    contentfulResourceLibraryPage {
      pageMeta {
        ...PageMeta
      }
      hero {
        ...TextHero
      }
    }
    allContentfulResource (filter: {slug: {ne: "fpo-test"}}) {
      edges {
        node {
          ...ResourceCard
        }
      }
    }
  }
`;
